import { render } from "./BatteryPanelClient.vue?vue&type=template&id=11dab710"
import script from "./BatteryPanelClient.vue?vue&type=script&lang=js"
export * from "./BatteryPanelClient.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__